<script lang="ts" setup>
import { DrawerTitle } from 'vaul-vue';

import { cn } from '@/components/lib/shadcn-vue/utils';

import type { DrawerTitleProps } from 'vaul-vue';
import type { HtmlHTMLAttributes } from 'vue';
const props = defineProps<DrawerTitleProps & { class?: HtmlHTMLAttributes['class'] }>();
const delegatedProps = computed(() => {
  const { ...delegated } = props;
  return delegated;
});
</script>

<template>
  <DrawerTitle v-bind="delegatedProps" :class="cn('text-lg font-semibold leading-none tracking-tight', props.class)">
    <slot />
  </DrawerTitle>
</template>
